import { SyncExternalStore } from '@egr/xbox/utils/SyncExternalStore';

class ShowArticleInformationStore extends SyncExternalStore<{
    showInformation: boolean;
}> {
    constructor() {
        super({
            showInformation: false,
        });
    }

    public toggleDisplayInformation(): void {
        this.updateState({
            showInformation: !this.snapshot.showInformation,
        });
    }
    public setShowInformation(show: boolean) {
        this.updateState({
            showInformation: show,
        });
    }
}

export const showArticleInformationStore = new ShowArticleInformationStore();
